module.exports = __webpack_public_path__ + "img/DNARepair-BRCA_10X_Section1.535c38b9.png";